import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import firebase from 'firebase'
import { addimg } from '../globalState/slice'
import Slider from "react-slick";
import hunter from '../assets/hunter.png'
import sudo from '../assets/hunter (2).jpeg'


export const SimpleSlider = () => {


    let dbImg = firebase.firestore().collection('images')
    const dispatch = useDispatch()
    const selector = useSelector((state) => {
        return state.brandReducer.images
    })
    // console.log(selector)
    useEffect(() => {
        const imgDb = async () => {
            dbImg.orderBy("time", "desc").onSnapshot((dataDb) => {

                const images = []
                dataDb.forEach((val) => {

                    let img = val.data()
                    let id = val.id
                    img.id = id
                    images.push(img)
                })
                dispatch(addimg(images))
            })
        }
        imgDb()
    }, [])

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: selector.length < 3 ? 1 : selector.length > 5 ? 3 : 2,
        // slidesToShow:6,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2500,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: selector.length > 5 ? 3 : 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: selector.length > 5 ? 3 : 1,
                    slidesToScroll: 1,
                    // initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: selector.length > 5 ? 2 : 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    // const onResumeClick=()=> {
    //     window.open(pdf);
    //   }

    return (
        <div className='slider_container' id='brands'>
            <div className="slider_main_div">
                <div className='from_head'>
                    <h3><strong className='slider_heead' style={{ color: '#353336' }}>Nuestras <b > Marcas</b></strong></h3>
                </div>
                {/* <a href="https://www.flipsnack.com/C5D8AEEEFB5/cat-logo-oficial-hunter-2021/full-view.html" target='_blank'>

                    <button className='upload_btn slider_btn'>Ver Catálogo</button>
                </a> */}

                {/* {selector.length ?
                    <Slider {...settings} >
                        {selector.length && selector.map((val, i) => (
                            <div key={i}>
                                <a href="https://www.flipsnack.com/petcost/cat-logo-oficial-hunter-2021/full-view.html" 
                                target="_blank" 
                                rel="noopener noreferrer">
                                    <img
                                        className="d-block slider_img"
                                        src={val.img}
                                        alt="First slide"
                                    />
                                </a>
                            </div>
                        ))}
                    </Slider>
                    : null} */}
                <Slider {...settings}>
                    <div>
                        <a href="https://www.flipsnack.com/C5D8AEEEFB5/cat-logo-oficial-hunter-2021/full-view.html" target='_blank'>
                            <img className="slider_img" src={hunter} alt="" />
                        </a>
                    </div>
                    <a  href="https://www.flipsnack.com/petcost/cata-logo-sodapup/full-view.html" target='_blank' >
                        <img className="slider_img" src={sudo} alt="" />
                    </a>
                </Slider>
            </div>


        </div>
    );
}